"use client";
import React from "react";
import Link from "next/link";
import { renderButtonStyle } from "../utils/render-button-style";

interface BookButtonProps {
  data: {
    id: string;
    url: string;
    text: string;
    type: string;
    newTab: boolean;
  };
}

export default function BookButton({ data }: BookButtonProps) {
  return (
    <section className="mx-auto w-full px-4 py-16 sm:px-6 lg:px-8 lg:py-12 bg-white">
      <div className="lg:text-4xl xl:text-4xl text-3xl text-center text-slate-900 lg:font-bold xl:font-bold font-semibold">
        <Link
          href={data.url}
          target={data.newTab ? "_blank" : "_self"}
          className={`transition duration-100 ease-in-out hover:text-white hover:bg-violet-400 shadow-md  ${renderButtonStyle(
            data.type
          )}`}
        >
          {data.text}
        </Link>
      </div>
    </section>
  );
}
